// extracted by mini-css-extract-plugin
export default {"content":"Artists_content__h1jT7"};